import { Card } from "../components";

const AnimationCards = () => {
  return (
    <div id="animation-cards">
      <div className="container">
        <div className="title">
          <h5 className="text-center font_change_color">Animations</h5>
          <h1 className="text-center">Card</h1>
        </div>
        <div className="row d-flex justify-content-center m-0">
          <div className="col-12 col-sm-8 col-md-6 col-lg-4 my-3 py-5">
            <Card />
          </div>
          <div className="col-12 col-sm-8 col-md-6 col-lg-4 my-3 py-5">
            <Card
              title="Card Two"
              className="two"
              cardStyle={{
                backgroundLine: "linear-gradient(-45deg, #0CA0EC, #F40660)",
                skew: "skew(20deg)",
              }}
            />
          </div>
          <div className="col-12 col-sm-8 col-md-6 col-lg-4 my-3 py-5">
            <Card
              title="Card Three"
              className="three"
              cardStyle={{
                backgroundLine: "linear-gradient(-45deg, #03E6F2, #3FFF0B)",
                skew: "skew(-20deg)",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimationCards;
